import { useState, useRef, useEffect } from 'react';
import './App.css';

function App() {
  const [showCrosschain, setShowCrosschain] = useState(false);
  const tweetsRef = useRef(null);

  const scrollTweets = (direction) => {
    if (tweetsRef.current) {
      const scrollAmount = 350;
      tweetsRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    if (tweetsRef.current) {
      tweetsRef.current.scrollLeft = tweetsRef.current.scrollWidth;
    }
  }, []);

  const features = [
    {
      id: 'antisnipe',
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M24 4L6 12v12c0 11 8 18 18 22 10-4 18-11 18-22V12L24 4z" />
          <path d="M16 24l6 6 10-12" />
        </svg>
      ),
      title: 'Anti-sniping protection'
    },
    {
      id: 'supply',
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="24" cy="24" r="18" />
          <path d="M24 12v24M12 24h24" />
          <circle cx="24" cy="24" r="6" />
        </svg>
      ),
      title: 'Supply management'
    },
    {
      id: 'discovery',
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M8 36l8-12 8 8 8-16 8 12" />
          <circle cx="36" cy="28" r="4" />
        </svg>
      ),
      title: 'Organic price discovery'
    },
    {
      id: 'strategies',
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="6" y="6" width="14" height="14" rx="2" />
          <rect x="28" y="6" width="14" height="14" rx="2" />
          <rect x="6" y="28" width="14" height="14" rx="2" />
          <rect x="28" y="28" width="14" height="14" rx="2" />
          <path d="M20 13h8M13 20v8M35 20v8M20 35h8" />
        </svg>
      ),
      title: 'MEV and algorithmic trading strategies'
    },
    {
      id: 'latency',
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          <circle cx="32" cy="32" r="12" />
          <path d="M32 26v8l4 2" />
        </svg>
      ),
      title: 'Low latency real time decision making'
    },
    {
      id: 'fairness',
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="24" cy="12" r="8" />
          <circle cx="12" cy="36" r="6" />
          <circle cx="36" cy="36" r="6" />
          <path d="M24 20v8M18 32l-2-4M30 32l2-4" />
        </svg>
      ),
      title: 'Fair distribution'
    }
  ];

  const chains = [
    { name: 'Solana', logo: '◎' },
    { name: 'Crosschain', logo: '⟷', isCrosschain: true },
    { name: 'BNB Chain', logo: '⬡' }
  ];

  const lookingFor = [
    {
      type: 'Investors',
      skills: ['Capital', 'Network', 'Strategy']
    },
    {
      type: 'Creators',
      skills: ['Design', 'Live streaming', 'Visuals']
    },
    {
      type: 'Marketers',
      skills: ['Growth', 'Community', 'Partnerships']
    },
    {
      type: 'Builders',
      skills: ['Front-end', 'Backend', 'Infrastructure']
    }
  ];

  const tweets = [
    { date: 'Day 1', content: 'Logo and naming. Brand identity. Domain and X profile.', link: 'https://x.com/ivari_ink/status/1993041101939155390' },
    { date: 'Day 2', content: 'Developed and deployed version_0 website: ivari.ink. Preparation for development live streams.', link: 'https://x.com/ivari_ink/status/1993756345695179233' },
    { date: 'Day 3', content: 'Launch first stream, was happy to talk with you guys! Implement USD value display for MM terminal. Fix PancakeSwap transaction parser.', link: 'https://x.com/ivari_ink/status/1996002015197921786' },
    { date: 'Day 4', content: 'Working on traders wallet dashboard.', link: 'https://x.com/ivari_ink/status/1996365409822396821' },
    { date: 'Day 5', content: 'Trader wallet dashboards ready.', link: 'https://x.com/ivari_ink/status/1996700525484552595' },
    { date: 'Day 6', content: 'Started building the landing page.', link: 'https://x.com/ivari_ink/status/1998464777199489458' },
    { date: 'Day 7', content: 'Landing page continue.', link: 'https://x.com/ivari_ink/status/1998884350163603458' },
  ];

  const roadmap = [
    {
      phase: 'PHASE 01',
      title: 'Foundation',
      description: 'Core infrastructure, anti-sniper module, and initial Solana integration',
      status: 'completed'
    },
    {
      phase: 'PHASE 02',
      title: 'Expansion',
      description: 'BNB Chain integration, AI-driven strategies, and community building',
      status: 'current'
    },
    {
      phase: 'PHASE 03',
      title: 'Scale',
      description: 'Multi-chain support, advanced trading algorithms, and partner integrations',
      status: 'upcoming'
    },
    {
      phase: 'PHASE 04',
      title: 'IVARI Terminal',
      description: 'Business to business service model, we trade for you',
      status: 'upcoming'
    },
    {
      phase: 'PHASE 05',
      title: 'IVARI Tools',
      description: 'Subscription software as a service model, become market maker - trade for yourself',
      status: 'upcoming'
    }
  ];

  return (
    <div className="app">
      {/* Animated Background */}
      <div className="background-gradient" />
      <div className="background-orbs">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
        <div className="orb orb-3" />
        <div className="orb orb-4" />
      </div>
      <div className="grid-bg" />
      <div className="noise-overlay" />

      {/* Green Threads Animation */}
      <div className="threads-container">
        <div className="thread thread-1" />
        <div className="thread thread-2" />
        <div className="thread thread-3" />
        <div className="thread thread-4" />
        <div className="thread thread-5" />
      </div>

      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Ivari" />
            <span>IVARI</span>
          </div>
          <nav className="header-nav">
            <a href="#features">What We Do</a>
            <a href="#looking-for">Join Us</a>
            <a href="#roadmap">Roadmap</a>
            <a href="https://x.com/ivari_ink" target="_blank" rel="noopener noreferrer">Contact Us</a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="highlight">Market Making</span>
            <span className="hero-title-sub">for Everyone</span>
          </h1>
          <div className="hero-cta-group">
            <a
              href="https://x.com/ivari_ink"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button primary"
            >
              Get Started
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a href="#features" className="cta-button secondary">
              Learn More
            </a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-glow" />
          <div className="hero-ring hero-ring-1" />
          <div className="hero-ring hero-ring-2" />
          <div className="hero-ring hero-ring-3" />
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="section-header">
          <h2 className="section-title">What We Do</h2>
        </div>
        <div className="features-grid six-cols">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="card-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Supported Chains */}
      <section
        className="chains"
        onMouseEnter={() => setShowCrosschain(true)}
        onMouseLeave={() => setShowCrosschain(false)}
      >
        <div className="chains-label">Supported Chains</div>
        <div className={`chains-content ${showCrosschain ? 'show-info' : ''}`}>
          <div className="chains-list">
            {chains.map((chain, idx) => (
              <div key={idx} className={`chain-item ${chain.isCrosschain ? 'crosschain-item' : ''}`}>
                <span className={`chain-logo ${chain.isCrosschain ? 'pulse' : ''}`}>{chain.logo}</span>
                <span className="chain-name">{chain.name}</span>
              </div>
            ))}
          </div>
          <div className="chains-info">
            <p>Our cross-chain architecture lets us integrate any new chain in days — so we're always first to market.</p>
          </div>
        </div>
      </section>

      {/* Who We're Looking For */}
      <section id="looking-for" className="looking-for">
        <div className="section-header">
          <h2 className="section-title">Who We're Looking For</h2>
        </div>
        <div className="looking-for-grid">
          {lookingFor.map((item, idx) => (
            <div key={idx} className="looking-for-card">
              <div className="looking-for-icon">
                {item.type === 'Investors' && (
                  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="24" cy="16" r="10" />
                    <path d="M8 44c0-8.8 7.2-16 16-16s16 7.2 16 16" />
                    <path d="M30 14l4-4M34 10v8M30 14h8" />
                  </svg>
                )}
                {item.type === 'Creators' && (
                  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="24" cy="24" r="18" />
                    <polygon points="20,16 32,24 20,32" fill="currentColor" />
                  </svg>
                )}
                {item.type === 'Marketers' && (
                  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M6 38V22l18-12 18 12v16" />
                    <path d="M6 38h36" />
                    <circle cx="24" cy="26" r="6" />
                    <path d="M24 32v6" />
                  </svg>
                )}
                {item.type === 'Builders' && (
                  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M8 40l6-6M14 34l12-12M26 22l8-8" />
                    <rect x="30" y="8" width="10" height="10" rx="2" transform="rotate(45 35 13)" />
                    <path d="M8 40l-2 2M40 40l-16-16" />
                  </svg>
                )}
              </div>
              <h3>{item.type}</h3>
              <div className="looking-for-skills">
                {item.skills.map((skill, sidx) => (
                  <span key={sidx} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Roadmap */}
      <section id="roadmap" className="roadmap">
        <div className="section-header">
          <h2 className="section-title">Roadmap</h2>
        </div>
        <div className="metro-map">
          <div className="metro-line" />
          {roadmap.map((item, idx) => (
            <div key={idx} className={`metro-node ${item.status}`}>
              <div className="node-marker">
                {item.status === 'completed' && (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <path d="M5 12l5 5L19 7" />
                  </svg>
                )}
                {item.status === 'current' && <div className="pulse-ring" />}
              </div>
              <div className="node-content">
                <div className="node-header">
                  <span className="node-number">{item.phase}</span>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Daily Updates / Tweets */}
      <section className="updates">
        <div className="section-header">
          <h2 className="section-title">Building in Public</h2>
        </div>
        <div className="tweets-container">
          <button className="tweets-nav tweets-nav-left" onClick={() => scrollTweets('left')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <div className="tweets-scroll" ref={tweetsRef}>
            {tweets.map((tweet, idx) => (
              <div key={idx} className="tweet-card">
                <div className="tweet-header">
                  <div className="tweet-avatar">
                    <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Ivari" />
                  </div>
                  <div className="tweet-meta">
                    <span className="tweet-name">Ivari</span>
                    <span className="tweet-handle">@ivari_ink</span>
                  </div>
                  <span className="tweet-date">{tweet.date}</span>
                </div>
                <p className="tweet-content">{tweet.content}</p>
                <a
                  href={tweet.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tweet-link"
                >
                  View on X
                </a>
              </div>
            ))}
          </div>
          <button className="tweets-nav tweets-nav-right" onClick={() => scrollTweets('right')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="glass-card">
          <div className="cta-glow" />
          <h2>Ready to Launch?</h2>
          <p>Partner with Ivari for market making solutions. Our team is ready to help you achieve your goals.</p>
          <div className="cta-features">
            <div className="cta-feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12l5 5L19 7" />
              </svg>
              <span>Free consultation</span>
            </div>
            <div className="cta-feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12l5 5L19 7" />
              </svg>
              <span>Custom solutions</span>
            </div>
            <div className="cta-feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12l5 5L19 7" />
              </svg>
              <span>24/7 support</span>
            </div>
          </div>
          <a
            href="https://x.com/ivari_ink"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button primary large"
          >
            Contact Us
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-bottom">
          <p className="footer-copy">&copy; 2024 Ivari. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
